import "./user-info.style.scss";

import { Fragment, useState } from "react";

import QRCode from "qrcode.react";
import { QRTypes, changeQRColor } from "../../utils/QR/get-QRcolor";
import ErrorMessage from "../error-message/error-message";
import { USER_ROLES } from "../../utils/user-roles/user-roles";
import { capitalizeNames, convertTimeWithTimezone } from "../../utils/helpers";
import createReducePaymentIntentAPI from "../../apis/create-reduce-payment-intent";
import BeatSpinner from "../loading-indicator/beat-loader";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../checkout-form/checkout-form";
import { TransferPopup } from "../popup/transfer-popup/transfer-popup";

const UserInfo = ({ eventId, promotorId, uniqueHash, payLoad }) => {
  const [showPaymentView, setShowPaymentView] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [showTransferPopup, setShowTransferPopup] = useState(
    payLoad.isTransfered ? !payLoad.isInfoUpdatedAfterTransfer ?? false : false
  );
  const [ticketTransfered, setTicketTransfered] = useState({
    isTransfered: false,
    email: "",
  });
  // const [selectedTicket, setSelectedTicket] = useState(
  //   payLoad.tickets ? payLoad.tickets[0] : null
  // );

  if (!payLoad.member) {
    return <ErrorMessage />;
  }

  if (!payLoad?.isTransfered && ticketTransfered.isTransfered) {
    return (
      <ErrorMessage
        errorMessage={`Ticket has been transfered to`}
        boldDesc={ticketTransfered?.email ?? ""}
      />
    );
  }

  const QRdata = JSON.stringify({
    eventId: eventId,
    promotorId: promotorId,
    code: payLoad.code,
    doormanId: payLoad.doorman,
    uniqueHash: uniqueHash,
    type: payLoad.type,
    isExpressEntry: payLoad.isExpressEntry,
    imageUrl: payLoad.imageUrl,
    fullName: payLoad.fullName,
    invitedBy: payLoad.member.fullName,
    inviteId: payLoad.id,
    ticketType: payLoad?.ticketType ?? "",
    email: payLoad?.email ?? "",
    isPaid: payLoad?.transaction !== null && payLoad?.transaction !== undefined,
  });

  const QRcolor = changeQRColor(
    // payLoad.ticket
    //   ? payLoad.availableTicket.ticketType.name.toLowerCase() :
    !payLoad.transaction && payLoad.type,
    payLoad.member.email
  );

  const checkConditionForDisplayingPaymentBtn = () => {
    if (
      payLoad.type?.toLowerCase() === QRTypes.reduce &&
      // payLoad.tickets?.length > 0 &&
      payLoad.transaction?.paymentStatus !== "completed" &&
      payLoad.availableTicket.price !== 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  const createReducePaymentIntentAndSetupStripe = async () => {
    try {
      setIsLoading(true);
      const response = await createReducePaymentIntentAPI(
        payLoad.id,
        payLoad.availableTicket.ticketType.name,
        payLoad.availableTicket.id
      );

      if (response.status === "Success") {
        setStripePromise(loadStripe(response.payLoad.publishableKey));
        setClientSecret(response.payLoad.paymentIntent);
        setShowPaymentView(true);
      }
    } catch (error) {
      setErrorMessage(error.message);
      console.error("Error creating PaymentIntent:", error);
    } finally {
      setIsLoading(false);
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
    }
  };

  function onTransferClicked() {
    setShowTransferPopup(true);
  }

  function renderTransferView() {
    return (
      <div className="transfer-container">
        <button className="transfer-button" onClick={onTransferClicked}>
          {"Transfer"}
        </button>
        <p className="transfer-description">
          <strong>Unable to attend?</strong>
          <br />
          Transfer your ticket to a friend
        </p>
      </div>
    );
  }

  if (showPaymentView) {
    return (
      <Fragment>
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <CheckoutForm
            payLoad={payLoad}
            clientSecret={clientSecret}
            // selectedTicket={selectedTicket}
            availableTicket={payLoad.availableTicket}
          />
        </Elements>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <div className="event-information">
        <p className="event-name">{payLoad.event.eventName}</p>
        <p className="event-date">
          {convertTimeWithTimezone(payLoad.event.startTime)}
        </p>
        <p className="event-location">{payLoad.event.location}</p>
        <div className="profile-image">
          <img src={payLoad.event.imageUrl} alt="Profile" />
        </div>

        <p className="user-name">
          <strong>Guest name: </strong>
          {capitalizeNames(payLoad.fullName)}
        </p>
        <p className="user-name">
          <strong>Invited by: </strong>
          {payLoad.member.userType === USER_ROLES.ADMIN
            ? "Event Owner"
            : capitalizeNames(payLoad.member.fullName)}{" "}
        </p>
      </div>

      <div className="profile-info">
        {/* <h2 className="invited-by">Invited by</h2>
        <p className="invited-by-name">
          {payLoad.member.userType === USER_ROLES.ADMIN
            ? "Event Owner"
            : capitalizeNames(payLoad.member.fullName)}
          </p>*/}
        <h3 className="selected-ticket-name">
          {payLoad.transaction
            ? "Paid Ticket"
            : payLoad.type.toLowerCase() === QRTypes.comps
            ? "Complimentary Ticket"
            : payLoad.availableTicket.ticketType.name + " Ticket"}
        </h3>
      </div>

      {
        // payLoad.email.includes("noreply") &&
        // payLoad.member.userType === USER_ROLES.ADMIN && (
        <p className="QR-optional-text">
          {`Present your QR Code`}
          <br />
          {`at the door to`}
          {payLoad.type.toLowerCase() === QRTypes.reduce && !payLoad.transaction
            ? " receive your reduced "
            : " claim your "}
          {/*payLoad.type === QRTypes.comps || payLoad.type === QRTypes.COMPS
                ? " complementary "
            : " reduced "*/}
          ticket
        </p>
      }

      <div className="QR-content">
        {/*{payLoad.type === QRTypes.REDUCE || payLoad.type === QRTypes.reduce ? (*/}
        {/*  <div className="QR-reduce-type-text-container">*/}
        {/*    <p className="QR-reduce-type-text"> Reduce Ticket</p>*/}
        {/*  </div>*/}
        {/*) : (*/}
        {/*  ""*/}
        {/*)}*/}

        {/*{payLoad.type === QRTypes.COMPS || payLoad.type === QRTypes.comps ? (*/}
        {/*  <div className="QR-reduce-type-text-container">*/}
        {/*    <p className="QR-comps-type-text"> Comp Ticket</p>*/}
        {/*  </div>*/}
        {/*) : (*/}
        {/*  ""*/}
        {/*)}*/}

        {/*<p className="message-text">*/}
        {/*  {payLoad.isVerified*/}
        {/*    ? "Your check-in was successfully verified"*/}
        {/*    : "Present this barcode at the door for expedited entry"}*/}
        {/*</p>*/}

        <div className="QR-code-container">
          <QRCode value={QRdata} fgColor={QRcolor} />

          <p className="code"> code: {payLoad.code}</p>
        </div>
      </div>

      {payLoad.type.toLowerCase() === QRTypes.reduce &&
        !payLoad.transaction && (
          <div style={{ marginTop: "10px" }}>
            <span className="QR-optional-text">
              Reduced Ticket is valid subject to venue capacity
            </span>
          </div>
        )}

      {/*<div className="text-container">*/}
      {/*  <p className="venue-text">*/}
      {/*    <strong>Venue:</strong> {payLoad.event.location}*/}
      {/*  </p>*/}
      {/*</div>*/}
      {checkConditionForDisplayingPaymentBtn() && (
        <Fragment>
          {
            // <div className="separator"></div>
            // <h2 className="ticket-type-heading">Choose Ticket</h2>
            // <div className="view-toggle">
            //   {payLoad.tickets.map((ticket) => (
            //     <button
            //       key={ticket.id}
            //       className={`toggle-button ${
            //         selectedTicket.id === ticket.id
            //           ? `active-${
            //               selectedTicket.ticketType.name.toLowerCase() ===
            //               "reduce"
            //                 ? "reduce"
            //                 : "full"
            //             }`
            //           : ""
            //       }`}
            //       onClick={() => {
            //         setSelectedTicket(ticket);
            //       }}
            //     >
            //       <div>{ticket.ticketType.name}</div>
            //       <div className="price">${ticket.price}</div>
            //     </button>
            //   ))}
            // </div>
          }

          <button
            className="payment-button"
            disabled={isLoading}
            onClick={createReducePaymentIntentAndSetupStripe}
          >
            {isLoading ? (
              <BeatSpinner />
            ) : payLoad.type.toLowerCase() === QRTypes.reduce ? (
              "Secure Your Ticket Now!"
            ) : (
              "Save Time - Buy Ticket Now!"
            )}
          </button>
        </Fragment>
      )}

      {!payLoad.isTransfered && payLoad?.transaction && renderTransferView()}

      <TransferPopup
        data={payLoad}
        showPopup={showTransferPopup}
        onlyUpdateImage={
          payLoad.isTransfered && !payLoad.isInfoUpdatedAfterTransfer
        }
        onClosePressed={() => {
          setShowTransferPopup(false);
        }}
        onSubmitted={(data) => {
          setShowTransferPopup(false);
          setTicketTransfered({ isTransfered: true, email: data.email });
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }}
        onTicketInfoUpdated={() => {
          setShowTransferPopup(false);
        }}
      />

      {errorMessage && (
        <span className="error-message-payment">{errorMessage}</span>
      )}
      {/*<ProgressIndicator currentStep={3} totalSteps={3} />*/}
    </Fragment>
  );
};

export default UserInfo;
